import { twMerge } from "tailwind-merge";

export function SoftText({
  children,
  elementType,
  className,
  id,
}: {
  children: React.ReactNode;
  elementType: "p" | "span";
  className?: string;
  id?: string;
}) {
  const Element = elementType;

  return (
    <Element
      className={twMerge(
        "text-sm font-medium leading-6 text-gray-500",
        className
      )}
      id={id}
    >
      {children}
    </Element>
  );
}
